angular.module('tf.controllers')

    .controller('VerifyEmailController', function ($scope, NotificationService, $cookies, AuthService) {

        $scope.resendVerificationEmail = function(){
            var email = $cookies.get('user_email');
            if(email){
                AuthService.resendVerificationEmail(email).then(function () {
                    NotificationService.notify('info-alert', {content: "Please check your email to verify your account"});
                });
            }
        };
    })
;
